var _slicedToArray = require("C:/vagrant_tienda/apache/kinedu-educators-landing/node_modules/@babel/runtime/helpers/slicedToArray");

module.exports = function (e) {
  var t = {};

  function r(n) {
    if (t[n]) return t[n].exports;
    var o = t[n] = {
      i: n,
      l: !1,
      exports: {}
    };
    return e[n].call(o.exports, o, o.exports, r), o.l = !0, o.exports;
  }

  return r.m = e, r.c = t, r.d = function (e, t, n) {
    r.o(e, t) || Object.defineProperty(e, t, {
      enumerable: !0,
      get: n
    });
  }, r.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, r.t = function (e, t) {
    if (1 & t && (e = r(e)), 8 & t) return e;
    if (4 & t && "object" == typeof e && e && e.__esModule) return e;
    var n = Object.create(null);
    if (r.r(n), Object.defineProperty(n, "default", {
      enumerable: !0,
      value: e
    }), 2 & t && "string" != typeof e) for (var o in e) {
      r.d(n, o, function (t) {
        return e[t];
      }.bind(null, o));
    }
    return n;
  }, r.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return r.d(t, "a", t), t;
  }, r.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, r.p = "", r(r.s = 68);
}({
  1: function _(e, t) {
    e.exports = require("react");
  },
  68: function _(e, t, r) {
    "use strict";

    var n = this && this.__importDefault || function (e) {
      return e && e.__esModule ? e : {
        default: e
      };
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var o = r(1),
        u = n(r(7)),
        i = function i(_ref) {
      var e = _ref.children,
          t = _ref.rootId,
          r = _ref.insertBefore;

      var _o$useState = o.useState(document.createElement("div")),
          _o$useState2 = _slicedToArray(_o$useState, 1),
          n = _o$useState2[0];

      return n.classList.add("portal"), o.useEffect(function () {
        var e = document.getElementById(t);

        if (!e) {
          var _r = document.createElement("div");

          _r.id = t, document.body.append(_r), e = _r;
        }

        return r ? e.insertBefore(n, e.firstChild) : e.appendChild(n), function () {
          e && e.removeChild(n);
        };
      }, []), u.default.createPortal(e, n);
    };

    i.defaultProps = {}, t.default = i;
  },
  7: function _(e, t) {
    e.exports = require("react-dom");
  }
});